import { makePostApiCall } from "./makeApiCall";

/**
 * Normalize API dropdown objects, legacy plain strings, or null.
 */
export function normalizeDropdownOption(value) {
  if (value == null || value === "") {
    return null;
  }
  if (typeof value === "object" && value.value != null && value.value !== "") {
    return {
      value: value.value,
      label: value.label ?? String(value.value),
    };
  }
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) {
      return null;
    }
    return { value: null, label: trimmed };
  }
  return null;
}

export function dropdownLabel(value) {
  const normalized = normalizeDropdownOption(value);
  if (!normalized) {
    return "—";
  }
  return normalized.label || String(normalized.value ?? "—");
}

export function dropdownForPayload(value) {
  const normalized = normalizeDropdownOption(value);
  if (!normalized || normalized.value == null || normalized.value === "") {
    return null;
  }
  return {
    value: normalized.value,
    label: normalized.label ?? String(normalized.value),
  };
}

export async function fetchLocationsForDropdown() {
  return makePostApiCall("locationsForDropdown", {});
}

export async function fetchLocationZonesForDropdown(location) {
  const payload = {
    location: dropdownForPayload(location) ?? { value: location?.value },
  };
  return makePostApiCall("locationZonesForDropdown", payload);
}

export async function fetchLocationProductionRoomsForDropdown(location) {
  const payload = {
    location: dropdownForPayload(location) ?? { value: location?.value },
  };
  return makePostApiCall("locationProductionRoomsForDropdown", payload);
}
